const searchType = {
  nameAndDOB: '名称和DOB',
  nameAndDOBWithAddressReturned: '带地址的姓名和DOB',
  idNumber: '身份证号',
  idNumberWithAddressReturned: '带地址返回的ID号',
};

export default searchType;
